













import {Vue, Component, Prop} from "vue-property-decorator";

export interface SegmentItem {
  key: any;
  title: string;
}

@Component
export default class Segments extends Vue {
    @Prop() items: SegmentItem[];
    @Prop() selected: any; //selected key

    selectedIndex = 0;

    select(index: number) {
        if (index !== this.selectedIndex) {
            this.selectedIndex = index;
            this.$emit('selected', this.items[this.selectedIndex]);
        }
    }

    mounted() {
        if (this.selected) {
            const index = this.items.findIndex(item => item.key == this.selected);
            if (index >= 0) {
                this.selectedIndex = index;
            }
        }
    }

    setSelected(value: any) {
        const index = this.items.findIndex(item => item.key == value);
        if (index >= 0) {
            this.select(index);
        }
    }
}
